import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

const CustomTextField = styled((props) => (
  <TextField {...props} onChange={(e) => props.setState(e.target.value)} />
))(({ theme }) => ({
  "& .MuiOutlinedInput-input": {
    padding: "12px", // Adjust this as needed for your design
  },
  "& .MuiOutlinedInput-input::-webkit-input-placeholder": {
    color: theme.palette.text.secondary,
    opacity: "0.8",
  },
  "& .MuiOutlinedInput-input.Mui-disabled::-webkit-input-placeholder": {
    color: theme.palette.text.secondary,
    opacity: "1",
  },
  "& .Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderColor: theme.palette.grey[200],
  },
  "& input[type=number]": {
    // For Chrome, Safari, Edge, Opera
    MozAppearance: "textfield",
    "&::-webkit-outer-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
    "&::-webkit-inner-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
  },
}));

export default CustomTextField;
